import {i18n} from '@/plugins/i18n'

export const relatedMerchantType = {
    GATEWAY: 1,
    WALLET: 2,
    PSP: 3,
    PF: 4,
};

export const relatedMerchantTypeStr = {
    GATEWAY: i18n.t('related_merchant_type.gateway'),
    WALLET: i18n.t('related_merchant_type.wallet'),
    PSP: i18n.t('related_merchant_type.psp'),
    PF: i18n.t('related_merchant_type.pf'),

    get(type) {
        let type_str = null;

        Object.keys(relatedMerchantType).forEach(item => {
            if (relatedMerchantType[item] === type) {
                type_str = relatedMerchantTypeStr[item];
            }
        });

        return type_str;
    }
};

export const relatedMerchantTypeVariant = type => {
    if (type === relatedMerchantType.GATEWAY) {
        return 'success';
    }

    if (type === relatedMerchantType.PSP) {
        return 'success';
    }

    if (type === relatedMerchantType.WALLET) {
        return 'primary';
    }

    if (type === relatedMerchantType.PF) {
        return 'danger';
    }

    return 'warning';
};
